<script>
  export let id = undefined;
  export let value = "";
  export let type;
  export let label = "";
  export let required = false;
  export let isError = false;

  const openPicker = (event) => {
    const input = event.currentTarget;

    if (typeof input.showPicker !== "function") return;

    try {
      input.showPicker();
    } catch (_) {
      // The native click remains as a fallback when showPicker is restricted.
    }
  };

  const updateValue = (event) => {
    value = event.currentTarget.value;
  };
</script>

<div class="native-picker">
  {#if !value}
    <span class="native-picker-label">{label}{required ? " *" : ""}</span>
  {/if}
  <input
    {id}
    {value}
    {type}
    aria-label={label}
    class:empty={!value}
    class:error-border={isError}
    class="form-element-input"
    on:click={openPicker}
    on:input={updateValue}
    on:change
    on:focus
    on:blur
    on:keypress
  />
</div>

<style>
  .native-picker {
    position: relative;
    width: 100%;
  }

  .native-picker-label {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 6px;
    max-width: calc(100% - 42px);
    overflow: hidden;
    color: #c2bdbd;
    font-family: Arial, sans-serif;
    font-size: 14px;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
    transform: translateY(-50%);
  }

  input {
    box-sizing: border-box;
    width: 100%;
    cursor: pointer;
  }

  input.empty,
  input.empty::-webkit-datetime-edit,
  input.empty::-webkit-date-and-time-value {
    color: transparent !important;
  }
</style>
